var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3934 0.154297H3.81518C1.70844 0.154297 0 1.85428 0 3.95059V8.50615C0 10.6025 1.70844 12.3024 3.81518 12.3024H8.3934C10.5001 12.3024 12.2086 10.6025 12.2086 8.50615V3.95059C12.2086 1.85428 10.5001 0.154297 8.3934 0.154297ZM11.064 8.50615C11.064 9.97152 9.86606 11.1636 8.3934 11.1636H3.81518C2.34252 11.1636 1.14455 9.97152 1.14455 8.50615V3.95059C1.14455 2.48522 2.34252 1.29319 3.81518 1.29319H8.3934C9.86606 1.29319 11.064 2.48522 11.064 3.95059V8.50615Z",
    fill: "#000B33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11074 3.19824C4.42519 3.19824 3.05859 4.55808 3.05859 6.23528C3.05859 7.91248 4.42519 9.27232 6.11074 9.27232C7.79629 9.27232 9.16289 7.91248 9.16289 6.23528C9.16289 4.55808 7.79629 3.19824 6.11074 3.19824ZM6.11074 8.13343C5.05928 8.13343 4.20315 7.28154 4.20315 6.23528C4.20315 5.18826 5.05928 4.33713 6.11074 4.33713C7.1622 4.33713 8.01833 5.18826 8.01833 6.23528C8.01833 7.28154 7.1622 8.13343 6.11074 8.13343Z",
    fill: "#000B33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37648 3.37784C9.60167 3.37784 9.78422 3.19619 9.78422 2.97212C9.78422 2.74805 9.60167 2.56641 9.37648 2.56641C9.1513 2.56641 8.96875 2.74805 8.96875 2.97212C8.96875 3.19619 9.1513 3.37784 9.37648 3.37784Z",
    fill: "#000B33"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.82a772efd86c4bc0892a956d0b0d57e9.svg";
export { ForwardRef as ReactComponent };